module.exports = __webpack_public_path__ + "media/manage/opt-in-e4be9482.png";